import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiTwitter, FiMessageCircle, FiSend, FiGlobe, FiMail, FiTrendingUp } = FiIcons;

const Footer = () => {
  const socialLinks = [
    { icon: FiTwitter, href: '#', label: 'Twitter' },
    { icon: FiMessageCircle, href: '#', label: 'Discord' },
    { icon: FiSend, href: '#', label: 'Telegram' },
    { icon: FiGlobe, href: '#', label: 'Website' },
    { icon: FiMail, href: '#', label: 'Email' }
  ];

  const quickLinks = [
    { name: 'Buy $PINKZILLA', href: 'https://pump.fun/AV1AQPodLxw43q7qB7c8HXHx6NrMSGi9z3tb4U7ypump' },
    { name: 'Whitepaper', href: '#' },
    { name: 'Tokenomics', href: '#tokenomics' },
    { name: 'Roadmap', href: '#roadmap' },
    { name: 'Community', href: '#community' }
  ];

  return (
    <footer className="bg-gray-900 text-white py-16 px-4">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          {/* Logo and Description */}
          <div className="md:col-span-2">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="mb-6"
            >
              <div className="flex items-center space-x-2 mb-4">
                <div className="w-10 h-10 bg-gradient-to-r from-pink-500 to-purple-600 rounded-full flex items-center justify-center">
                  <SafeIcon icon={FiTrendingUp} className="text-white text-xl" />
                </div>
                <span className="text-2xl font-bold bg-gradient-to-r from-pink-400 to-purple-400 bg-clip-text text-transparent">
                  PinkZilla
                </span>
              </div>
              <p className="text-gray-400 text-lg mb-6 max-w-md">
                The revolutionary meme coin that's taking the crypto world by storm. 
                Join the PinkZilla army and be part of the next big thing in crypto!
              </p>
              <motion.a
                href="https://pump.fun/AV1AQPodLxw43q7qB7c8HXHx6NrMSGi9z3tb4U7ypump"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="bg-gradient-to-r from-pink-500 to-purple-600 text-white px-6 py-3 rounded-full font-bold inline-flex items-center space-x-2"
              >
                <SafeIcon icon={FiTrendingUp} />
                <span>Buy Now</span>
              </motion.a>
            </motion.div>
          </div>

          {/* Quick Links */}
          <div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              <h3 className="text-xl font-bold mb-6">Quick Links</h3>
              <ul className="space-y-3">
                {quickLinks.map((link, index) => (
                  <li key={index}>
                    <a
                      href={link.href}
                      className="text-gray-400 hover:text-pink-400 transition-colors"
                      target={link.href.startsWith('http') ? '_blank' : '_self'}
                      rel={link.href.startsWith('http') ? 'noopener noreferrer' : ''}
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </motion.div>
          </div>

          {/* Social Links */}
          <div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <h3 className="text-xl font-bold mb-6">Follow Us</h3>
              <div className="flex space-x-4">
                {socialLinks.map((social, index) => (
                  <motion.a
                    key={index}
                    href={social.href}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    className="w-10 h-10 bg-gradient-to-r from-pink-500 to-purple-600 rounded-full flex items-center justify-center hover:from-pink-600 hover:to-purple-700 transition-all"
                    title={social.label}
                  >
                    <SafeIcon icon={social.icon} className="text-white" />
                  </motion.a>
                ))}
              </div>
            </motion.div>
          </div>
        </div>

        {/* Bottom Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="border-t border-gray-800 pt-8"
        >
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              <p>&copy; 2024 PinkZilla. All rights reserved.</p>
              <p className="mt-1">
                Contract: <span className="text-pink-400 font-mono">AV1AQPodLxw43q7qB7c8HXHx6NrMSGi9z3tb4U7ypump</span>
              </p>
            </div>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-pink-400 transition-colors">Privacy Policy</a>
              <a href="#" className="text-gray-400 hover:text-pink-400 transition-colors">Terms of Service</a>
              <a href="#" className="text-gray-400 hover:text-pink-400 transition-colors">Disclaimer</a>
            </div>
          </div>
        </motion.div>

        {/* Disclaimer */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-8 p-4 bg-gray-800 rounded-lg"
        >
          <p className="text-gray-400 text-xs text-center">
            <strong>Disclaimer:</strong> Cryptocurrency investments carry significant risk. 
            Past performance does not guarantee future results. Please do your own research 
            and only invest what you can afford to lose. PinkZilla is a meme coin created for 
            entertainment purposes.
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;